import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const ProductIot = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 40 40">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#F5E4E7"/>
      <path d="M19.168 14.1667L15.0013 17.5H11.668V22.5H15.0013L19.168 25.8334V14.1667Z" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M25.8909 14.1083C27.4531 15.6711 28.3308 17.7903 28.3308 20C28.3308 22.2097 27.4531 24.3289 25.8909 25.8917M22.9492 17.05C23.7303 17.8314 24.1692 18.891 24.1692 19.9958C24.1692 21.1007 23.7303 22.1603 22.9492 22.9417" stroke="#C72037" strokeWidth="2.08" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </SvgIcon>
  );
}

export default ProductIot;

